<ngb-timepicker
    [ngModel]="selectedMoment"
    [disabled]="disabled"
    (ngModelChange)="pick($event)"
    [seconds]="true"
></ngb-timepicker>
